import {Component, effect, input, output} from '@angular/core';
import {FormControl, FormGroup, ReactiveFormsModule, Validators} from '@angular/forms';
import {TranslatePipe} from '@ngx-translate/core';
import {MailTemplateDetails} from '../../../../../../../api';
import {MailTemplateFormModel} from '../../models/mail-template-form-model';
import {TextInput} from '../../../../../../components/text-input/text-input';
import {LocalDropdown} from '../../../../../../components/local-dropdown/local-dropdown';
import {Editor} from '../../../../../../components/editor/editor';

export interface MailTemplateFormValue {
  id: number | null;
  name: string | null;
  object: string | null;
  body: string | null;
  localIsoCode: string | null;
}

@Component({
  selector: 'elcia-mail-template-form',
  imports: [ReactiveFormsModule, TranslatePipe, TextInput, LocalDropdown, Editor],
  templateUrl: './mail-template-form.html',
})
export class MailTemplateForm {
  initialValue = input<MailTemplateDetails | null>(null);
  onSubmit = output<MailTemplateFormValue>();

  protected readonly form = new FormGroup<MailTemplateFormModel>({
    id: new FormControl<number | null>(null),
    name: new FormControl<string | null>(null, Validators.required),
    object: new FormControl<string | null>(null, Validators.required),
    body: new FormControl<string | null>(null, Validators.required),
    localIsoCode: new FormControl<string | null>(null, Validators.required),
  });

  private readonly onInitialValueChange = effect(() => {
    const template = this.initialValue();
    if (!template) {
      this.form.reset();
      return;
    }
    this.form.reset({
      id: template.id,
      name: template.name,
      object: template.object,
      body: template.body,
      localIsoCode: template.localIsoCode,
    });
  });

  public submit(): void {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }
    this.onSubmit.emit(this.form.getRawValue());
  }
}
